import React from 'react';
import PropTypes from 'prop-types';
import Paginator from 'components/Paginator';
import styled from 'styled-components/macro';

const PaginatorContainer = styled.div`
  margin-top: 2rem;
`;

function WrappedPaginator({ totalModules, page, perPage, setPage }) {
  return (
    <PaginatorContainer>
      <Paginator itemCount={totalModules} page={page} perPage={perPage} setPage={setPage} />
    </PaginatorContainer>
  );
}

WrappedPaginator.propTypes = {
  totalModules: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
};

export default WrappedPaginator;
